export const processingTablesDisabledTrue = [
  {
    label: "Molienda",
    value: "grinding",
    id: 1,
    disabled: false,
    fieldCalculation: "sample_quantity",
  },
  {
    label: "Tamizado",
    value: "sifting",
    id: 2,
    disabled: false,
    fieldCalculation: "wet_weight",
  },
  {
    label: "Secado",
    value: "drying",
    id: 3,
    disabled: false,
    fieldCalculation: "",
  },
  {
    label: "Calcinación",
    value: "calcination",
    id: 4,
    disabled: false,
    fieldCalculation: "",
  },
  {
    label: "Evaporación",
    value: "evaporation",
    id: 5,
    disabled: false,
    fieldCalculation: "sample_volume",
  },
  {
    label: "Digestión",
    value: "digestion",
    id: 6,
    disabled: false,
    fieldCalculation: "sample_quantity",
  },
  {
    label: "Virutado",
    value: "chipping",
    id: 8,
    disabled: false,
    fieldCalculation: "sample_quantity",
  },
  {
    label: "No Aplica",
    value: "not_applicable",
    id: 7,
    fieldCalculation: undefined,
  },
];

export const processingTablesDisabledFalse = [
  {
    label: "Molienda",
    value: "grinding",
    id: 1,
    disabled: false,
  },
  {
    label: "Tamizado",
    value: "sifting",
    id: 2,
    disabled: false,
  },
  {
    label: "Secado",
    value: "drying",
    id: 3,
    disabled: false,
  },
  {
    label: "Calcinación",
    value: "calcination",
    id: 4,
    disabled: false,
  },
  {
    label: "Evaporación",
    value: "evaporation",
    id: 5,
    disabled: false,
  },
  {
    label: "Digestión",
    value: "digestion",
    id: 6,
    disabled: false,
  },
  {
    label: "Virutado",
    value: "chipping",
    id: 8,
    disabled: false,
  },
  {
    label: "No Aplica",
    value: "not_applicable",
    id: 7,
  },
];

export const mapsProcessingCategory: any = {
  grinding: "1",
  sifting: "2",
  drying: "3",
  calcination: "4",
  evaporation: "5",
  digestion: "6",
  not_applicable: "7",
  chipping: "8",
};

export enum EnumProcessingOption {
  GRINDING = "grinding",
  SIFTING = "sifting",
  DRYING = "drying",
  CALCINATION = "calcination",
  EVAPORATION = "evaporation",
  DIGESTION = "digestion",
  CHIPPING = "chipping",
  NOT_APPLICABLE = "not_applicable",
}
